import { render } from "./SafetyAndAntiScamPolicy.vue?vue&type=template&id=07989d04&scoped=true"
import script from "./SafetyAndAntiScamPolicy.vue?vue&type=script&lang=js"
export * from "./SafetyAndAntiScamPolicy.vue?vue&type=script&lang=js"

import "./SafetyAndAntiScamPolicy.vue?vue&type=style&index=0&id=07989d04&scoped=true&lang=scss"
import "./SafetyAndAntiScamPolicy.vue?vue&type=style&index=1&id=07989d04&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07989d04"]])

export default __exports__